import { render } from "./LicensePageHeader.vue?vue&type=template&id=7f18d53c&ts=true"
import script from "./LicensePageHeader.vue?vue&type=script&lang=ts"
export * from "./LicensePageHeader.vue?vue&type=script&lang=ts"

import "./LicensePageHeader.vue?vue&type=style&index=0&id=7f18d53c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__